import { SceneSpine } from "GameObjects/StoryGame/SceneSpine";
import { SceneSprite } from "GameObjects/StoryGame/SceneSprite";
import { Bounce, Circ, Elastic, Expo, Linear, Sine, TimelineLite, TimelineMax, TweenLite } from "gsap";
import * as HLF from "html-living-framework";
import { Application } from "Singletons/Application";
import { AbstractStoryState } from "States/AbstractStoryState";
import { list } from "Utils/Reflection";

import { ch9_p01 } from "../../../layouts/ch9_p01/ch9_p01";

export class Chapter9Page1 extends AbstractStoryState implements ReturnType<typeof ch9_p01> {
    readonly bg = this.addChild(new SceneSprite());
    readonly hollyBack = this.addChild(new SceneSprite());
    readonly fence = this.addChild(new SceneSprite());
    readonly hollyMiddle = this.addChild(new SceneSprite());
    readonly lamb = this.addChild(new SceneSprite());
    readonly hollyFront = this.addChild(new SceneSprite());
    readonly frontSheep = this.addChild(new SceneSprite());

    public init(pSize: PIXI.Point, pData: any) {
        // exported layouts from Animate CC
        ch9_p01.call(this);
        // super.init calls onResize
        super.init(pSize, pData);
    }

    public update(pDeltaTime: number) {
        super.update(pDeltaTime);
    }

    public onResize(pSize: PIXI.Point) {
        super.onResize(pSize);
    }

    public animateIn(pOnComplete: () => void) {
        super.animateIn(pOnComplete);
    }

    public animateOut(pOnComplete: () => void) {
        super.animateOut(pOnComplete);
    }

    public onAnimateInComplete() {
        super.onAnimateInComplete();
        TweenLite.delayedCall(1.5, ()=>{
            this.gotoNextState({transition: "up"});
        });
    }
}